// 处理ag-grid单元格选择
//
import {
  ref,
  onMounted,
  onBeforeUnmount,
  Ref,
  ComponentPublicInstance
} from 'vue';

function checkTargetPosition(target: HTMLElement): boolean {
  if (target.hasAttribute('no-tooltip')) {
    return false;
  }

  if (target.classList && target.classList.contains('ag-cell-value')) {
    return true;
  }

  const parent = target.parentElement;
  if (parent) {
    return checkTargetPosition(parent);
  }

  return false;
}

function checkTextOverflow(e: HTMLElement) {
  return e.offsetWidth < e.scrollWidth;
}

function findBlockElement(target: HTMLElement): HTMLElement | null {
  if (target.classList && target.classList.contains('ag-cell-value')) {
    return target;
  }

  // inline,继续找上一级
  if (window.getComputedStyle(target).display.startsWith('inline')) {
    const parent = target.parentElement;
    if (!parent) return null;

    return findBlockElement(parent);
  }

  return target;
}

// <b> 是为了文本高亮, 需要换parentElement
function getRealTarget(target: HTMLElement) {
  if (target.tagName == 'B') {
    return target.parentElement!;
  }

  return target;
}

export function useAgGridToolTip(
  tableRef: Ref<ComponentPublicInstance>,
  virtualPopover: Ref<HTMLElement | undefined>
) {
  // ag-grid ref
  const textContentRef = ref<string | undefined>();

  function mouseOverHandle(e: MouseEvent) {
    const target = e.target as HTMLElement;

    if (checkTargetPosition(target)) {
      if (target.textContent) {
        const blockElement = findBlockElement(target);
        if (blockElement && checkTextOverflow(blockElement)) {
          const realTarget = getRealTarget(target);

          virtualPopover.value = realTarget;
          textContentRef.value = realTarget.textContent!;
        }
      }
    }
  }

  onMounted(() => {
    const table = tableRef.value.$el as HTMLElement;
    table.addEventListener('mouseover', mouseOverHandle);
  });

  onBeforeUnmount(() => {
	if(tableRef.value && tableRef.value.$el) {
      const table = tableRef.value.$el as HTMLElement;
      table.removeEventListener('mouseover', mouseOverHandle);
	}
  });

  return { tooltipContext: () => textContentRef };
}
